import React, { useState, useEffect } from 'react';
import { ChevronDown, ThumbsUp, ThumbsDown } from 'lucide-react';

/**
 * 검색어 강조
 */
const highlight = (text, keyword) => {
  if (!keyword || !keyword.trim()) return text;
  const safe = keyword.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const parts = String(text).split(new RegExp(`(${safe})`, 'gi'));
  return parts.map((part, i) =>
    part.toLowerCase() === keyword.trim().toLowerCase() ? (
      <mark key={i} className="bg-yellow-200 text-primary-900">
        {part}
      </mark>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    )
  );
};

const FAQItem = ({ faq, defaultOpen = false, searchTerm = '' }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [feedback, setFeedback] = useState(null); // 'yes' | 'no' | null

  // 검색 등으로 defaultOpen 이 바뀌면 동기화
  useEffect(() => {
    setIsOpen(defaultOpen);
  }, [defaultOpen]);

  return (
    <div className="mb-3 border border-accent-200 rounded-lg overflow-hidden">
      <button
        onClick={() => setIsOpen((v) => !v)}
        aria-expanded={isOpen}
        className="w-full flex items-center justify-between gap-3 p-4 bg-white hover:bg-accent-50 transition-colors text-left"
      >
        <div className="flex items-center gap-2 flex-1">
          {faq.category && (
            <span className="inline-flex flex-shrink-0 items-center px-2 py-0.5 rounded text-xs font-medium bg-primary-100 text-primary-800">
              {faq.category}
            </span>
          )}
          <span className="font-medium text-primary">
            {highlight(faq.question, searchTerm)}
          </span>
        </div>
        <ChevronDown
          size={20}
          className={`flex-shrink-0 text-accent-500 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>

      <div
        className={`overflow-hidden transition-all duration-200 ${
          isOpen ? 'max-h-[1000px]' : 'max-h-0'
        }`}
      >
        <div className="p-4 bg-secondary-50 border-t border-accent-200">
          <div className="text-sm text-primary leading-relaxed whitespace-pre-line">
            {highlight(faq.answer, searchTerm)}
          </div>

          {/* 도움이 되었나요? 피드백 (mock) */}
          <div className="mt-4 flex items-center gap-3 border-t border-accent-200 pt-3">
            {feedback ? (
              <p className="text-xs text-accent-600">
                {feedback === 'yes'
                  ? '소중한 의견 감사합니다!'
                  : '더 나은 답변을 위해 노력하겠습니다.'}
              </p>
            ) : (
              <>
                <span className="text-xs text-accent-600">
                  이 답변이 도움이 되었나요?
                </span>
                <button
                  onClick={() => setFeedback('yes')}
                  className="inline-flex items-center gap-1 rounded-md border border-accent-300 px-2 py-1 text-xs text-accent-700 hover:bg-white"
                >
                  <ThumbsUp size={12} />예
                </button>
                <button
                  onClick={() => setFeedback('no')}
                  className="inline-flex items-center gap-1 rounded-md border border-accent-300 px-2 py-1 text-xs text-accent-700 hover:bg-white"
                >
                  <ThumbsDown size={12} />
                  아니오
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQItem;
